import {useContext} from 'react';

import {TrackingContext} from '@homeaway/react-event-tracking';

function useTrackingContext() {
    return useContext(TrackingContext);
}

export {useTrackingContext};
